<template>
  <div id="mb-find-number" class="mb-find-number">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setValue(startGameConfig.mainImage.pos.x, 0) + 'px',
        left: setValue(startGameConfig.mainImage.pos.y, 0) + 'px',
      }"
    />
    <div
      class="find-number-answer-image"
      :key="'img-answer-state-' + ansIndex"
      v-for="(ans, ansIndex) in startGameConfig.answerState"
    >
      <transition name="find-number-fade">
        <img
          draggable="false"
          :src="giveMeImagePlease(ans.img.src)"
          v-if="ans.def == actualStatus"
          :style="{
            width: setValue(ans.img.width, 1920) + 'px',
            height: setValue(ans.img.height, 1080) + 'px',
            top: setValue(ans.img.pos.x, 0) + 'px',
            left: setValue(ans.img.pos.y, 0) + 'px',
          }"
        />
      </transition>
      <transition name="find-number-fade">
        <span
          :style="ans.textStyle"
          class="find-number-answer-text"
          v-if="ans.def == actualStatus"
          v-html="ans.text"
        ></span>
      </transition>
      <transition name="find-number-fade">
        <mb-audio
          v-if="ans.def == actualStatus && ans.audioSrc"
          :item-audio="{ audioSrc: ans.audioSrc, position: 'absolute', audioCss: ans.audioCss }"
        >
        </mb-audio>
      </transition>
    </div>
    <div class="find-number-answer-box" v-if="!this.startGameConfig.hideAnswer">
      <div
        class="find-number-answer-box-item"
        :style="{ background: setColor(tab.status) }"
        v-for="(tab, index) in table"
        :key="'find-number-answer-box-' + index"
      >
        {{ tab.value }}
      </div>
    </div>
    <div class="find-number-input" :style="startGameConfig.inputBoxStyle">
      <input
        :disabled="inputBlock"
        :maxlength="startGameConfig.maxLength"
        :style="startGameConfig.inputStyle"
        v-model="currentValue"
        @input="checkValue()"
      />
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
import MbAudio from '__mainSrcDir/components/MbAudio/MbAudio';
export default {
  name: 'mb-find-number',
  components: { MbAudio },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      table: [],
      currentValue: 0,
      savedValue: null,
      actualStatus: null,
      timer: null,
      inputBlock: false,
      correct: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    checkGameAction() {
      return this.inputBlock;
    },
    resetGameAction() {
      this.table = [];
      this.currentValue = 0;
      this.savedValue = null;
      this.actualStatus = null;
      this.timer = null;
      this.inputBlock = false;
      this.correct = null;
      this.$nextTick(() => {
        this.init();
      });

      this.show = true;
    },
    setOpacity(def) {
      if (def == this.actualStatus) return '1';
      else return '0';
    },
    setColor(status) {
      if (status == 'correct') {
        return 'green';
      } else if (status == 'incorrect') return 'red';
    },
    checkValue() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.checkTable(this.currentValue);
        // this.savedValue = this.currentValue;
      }, 800);
    },
    isValueIncorrect(value) {
      // if (value.lenght > 0) {
      if (
        value < this.table[0].value ||
        value > this.table[this.table.length - 1].value ||
        (value[0] == '0' && value.length > 1)
      ) {
        return true;
      } else {
        return false;
      }
      // }
      // return false;
    },
    checkTable(value) {
      if (this.isValueIncorrect(value)) {
        this.actualStatus = 'incorrect';
        if (value == '') this.actualStatus = '';
      } else {
        if (value == '') this.actualStatus = '';
        this.table.forEach((item, index) => {
          let type = this.correct - value;
          if (value == this.correct) {
            if (item.value == this.correct) {
              let it = this.table[index];
              it.status = 'correct';
              this.actualStatus = 'correct';
              this.inputBlock = true;
              this.$set(this.table, index, it);
              this.$store.dispatch('checkGame');
            }
          } else {
            if (type < 0 && item.value >= value) {
              let it = this.table[index];
              it.status = 'incorrect';
              this.$set(this.table, index, it);
              this.actualStatus = 'bigger';
            } else if (type > 0 && item.value <= value) {
              let it = this.table[index];
              it.status = 'incorrect';
              this.$set(this.table, index, it);
              this.actualStatus = 'smaller';
            }
          }
        });
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    init() {
      this.table = [];
      let i = this.startGameConfig.minNumber;
      while (i <= this.startGameConfig.maxNumber) {
        this.table.push({ value: i, state: 'nothing' });
        i += this.startGameConfig.gape;
      }
      this.setCorrect();
    },
    setCorrect() {
      if (this.startGameConfig.correct) {
        this.correct = _.cloneDeep(this.startGameConfig.correct);
        if (Array.isArray(this.correct)) {
          let tmpArray = this.shuffle(this.correct);
          this.correct = tmpArray[0];
        }
      } else {
        let randomValue = this.randomNumber(this.table.length, 0);
        this.correct = this.table[randomValue].value;
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandom(letters) {
      let tmp = '';
      tmp += letters[Math.floor(Math.random() * letters.length)];
      return tmp;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  destroyed() {},
  computed: {},
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: absolute
  object-fit: cover
.find-number-answer-image
  position: absolute
  top: 0
  left: 0
  width: 1920px
  height: 1080px
  .find-number-answer-text
    position: absolute
    bottom: 298px
    left: 786px
    color: white
    font-family: $gameFontFamily
    font-size: 64px
.mb-find-number
  font-family: $gameFontFamily
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .find-number-answer-box
    font-family: $gameFontFamily
    position: absolute
    top: 412px
    left: 580px
    flex-direction: row
    justify-content: center
    align-items: center
    text-align: center
    display: flex
    .find-number-answer-box-item
      width: 60px
      height: 60px
      border-radius: 50%
      margin: 2px
      display: flex
      justify-content: center
      align-items: center
      text-align: center
      font-size: 40px
  .find-number-input
    font-family: $gameFontFamily
    width: 380px
    height: 380px
    position: absolute
    top: 390px
    left: 80px
    border-radius: 50%
    overflow: hidden
    input
      border: none
      display: flex
      font-size: 140px
      font-weight: bold
      justify-content: center
      align-items: center
      text-align: center
      width: 100%
      height: 100%
      background: rgba(255,255,255,0.1)

.find-number-fade-leave-active, .find-number-fade-enter-active
  transition: all .3s linear
.find-number-fade-leave-to, .find-number-fade-enter
  opacity: 0
</style>
